import axios, { AxiosResponse } from "axios";

import { UPDATESURL, DOMIAN } from "../../shared/constants";
import { IAdminLogin } from "../../shared/dtos";
import { getCookie, removeAllCookies } from "./cookies";

const axiosInterceptor = axios.create({
  baseURL: UPDATESURL,
});

axiosInterceptor.interceptors.request.use(
  async (req) => {
    const token = getCookie("access_token");
    const userid = getCookie("userId");
    const deviceId = getCookie("deviceId");
    const source = getCookie("source") ? getCookie("source") : "WEB";

    req.headers.Authorization = `userId=${userid};deviceId=${deviceId};source=${source};finupdate_token=${token}`;
    return req;
  },
  (error) => Promise.reject(error),
);

axiosInterceptor.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response ? err.response.status : null;
    if (status === 401) {
      handleLogout();
    }
    return Promise.reject(err);
  },
);
const handleLogout = () => {
  removeAllCookies();
  setTimeout(() => {
    window.location.href = "/";
  }, 100);
};

export const GetBankDetailsBankUpdateAPICall = () => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/v1/api/bank_update/existing_bank_details`, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const GetProfileDetailsBankUpdateAPICall = () => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/api/V1/bank_update/profileDetails`, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const GetModificationsListBankUpdateAPICall = () => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/v1/api/bank_update/bank_modification_list`, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const GetModificationTypesBankUpdateAPICall = () => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/v1/api/bank_update/bank_modification_types`, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const GetCategoryBankUpdateAPICall = () => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/api/V1/bank_update/categoryDropdown/`, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const SendOtpBankUpdateAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/v1/api/bank_update/sendOTP`, requestBody, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const ReSendOtpBankUpdateAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/v1/api/bank_update/resend_otp`, requestBody, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const SecondaryBankRequestBankUpdateAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/v1/api/bank_update/validateOTP`, requestBody, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const PrimaryBankRequestBankUpdateAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/v1/api/bank_update/primary_bank`, requestBody, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const EsignCreateConsentBankUpdateAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/v1/api/bank_update/esign/create_consent/`, requestBody, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const EsignFillPdfBankUpdateAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/v1/api/bank_update/esign/esign_fill_pdf`, requestBody, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const GetEsignDocumentBankUpdateAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/v1/api/bank_update/esign/save_signed_document`, requestBody, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const FetchEsignPdfBankUpdateAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/api/V1/bank_update/fetch_esign_pdf/`, requestBody, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const UpdatePrimaryBankUpdateAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/api/V1/bank_update/primaryUpdate/`, requestBody, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const StageDetailsBankUpdateAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/v1/api/bank_update/stage_details/`, requestBody, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const SecondarytoPrimaryBankUpdateAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(
        `/v1/api/bank_update/secondary_to_primary_bank_mod`,
        requestBody,
        {},
      )
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const NewReversePennyDropRequestAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(
        `/v1/api/bank_update/stage/stage_bank/reverse_penny_request/`,
        requestBody,
        {},
      )
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const GetReversePennyDropStatusAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(
        `/v1/api/bank_update/stage/stage_bank/reverse_penny_status/`,
        requestBody,
        {},
      )
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
